import { createSignal, For, Match, Show, Switch, useContext } from 'solid-js';
import { AppContext } from '../../app-context-provider/app-context-provider';
import { Grid } from '../../grid-system/grid/grid';
import theme from '../../style/theme';
import { ErrorCatcher } from '../../tools/error-catcher';
import { Heading } from '../../ui-components/heading/heading';
import { AngleDownIcon } from '../icons-library/angle-down';
import { PostCard } from '../post-card/post-card';
import { RelatedPostsListProps } from './related-posts-list-types';
import {
    StyledPlaceHolderLatestArticlesBase,
    StyledPlaceHolderLatestArticlesListHorizontal,
    StyledPlaceHolderLatestArticlesListVertical,
    StyledPlaceHolderLatestArticlesVertical,
    StyledShowMoreButton,
} from './related-posts-list.style';

export const RelatedPostsList = (props: RelatedPostsListProps) => {    
    const { localize, viewport } = useContext(AppContext);

    const [currentPage, setCurrentPage] = createSignal(1);
    const postsPerPage = 3;
    const maxPages = () => props.relatedPosts.length / postsPerPage;
    const isLastPage = () => currentPage() >= maxPages();

    const isTablet = () => viewport.width <= theme.breakpoints.TABLET;

    const ShowMoreButton = (buttonProps: { orientation: 'vertical' | 'horizontal' }) => {
        return (
            <Show when={true}>
                <StyledShowMoreButton orientation={buttonProps.orientation} type="button" onClick={() => setCurrentPage(currentPage() + 1)}>
                    <div>{localize('show-more', 'show more')}</div>
                    <AngleDownIcon fill={theme.palette.red} {...{ height: 2.14, width: 2.86 }} ariaHidden />
                </StyledShowMoreButton>
            </Show>
        );
    };

    return (
        <ErrorCatcher componentName="Related posts list">
            <aside>
                <Switch>
                    <Match when={props.orientation === 'vertical' && !isTablet()}>
                        <StyledPlaceHolderLatestArticlesVertical>
                            <Heading tag={'h3'} variant={'medium'}>
                                {props.heading}
                            </Heading>
                            <StyledPlaceHolderLatestArticlesListVertical>
                                {/* TODO: it is better if we use real pagination here.. with fetching just 3 elements at once with offset and limit... So the plan is to fix it later */}
                                <For each={props.relatedPosts?.slice(0, currentPage() * postsPerPage)}>
                                    {(post) => {
                                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                        // @ts-ignore
                                        // TODO: fix types!
                                        const postContent = { ...post.content, url: '/' + post.content.url };
                                        return <PostCard orientation="vertical" data={postContent} inGrouping={true} />;
                                    }}
                                </For>
                                <Show when={!isLastPage()}>
                                    <ShowMoreButton orientation='vertical' />
                                </Show>
                            </StyledPlaceHolderLatestArticlesListVertical>
                        </StyledPlaceHolderLatestArticlesVertical>
                    </Match>
                    <Match when={props.orientation === 'horizontal' || isTablet()}>
                        <StyledPlaceHolderLatestArticlesBase>
                            <Heading tag={'h3'} variant={'medium'}>
                                {props.heading}
                            </Heading>
                            <StyledPlaceHolderLatestArticlesListHorizontal>
                                <Grid
                                    templateShorthand={[ 4, 4, 4 ]}
                                    responsive={{
                                        tablet: [ 6, 6 ],
                                        mobile: [ 12 ],
                                    }}
                                >
                                    {/* TODO: it is better if we use real pagination here.. with fetching just 3 elements at once with offset and limit... So the plan is to fix it later */}
                                    {/* <For each={props.relatedPosts.slice(0, currentPage() * postsPerPage)}> */}
                                    <For each={props.relatedPosts.slice(0, currentPage() * postsPerPage)}>
                                        {(post) => {
                                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                            // @ts-ignore
                                            // TODO: fix types!
                                            const postContent = { ...post.content, url: '/' + post.content.url };
                                            return <PostCard orientation="horizontal" data={postContent} />;
                                        }}
                                    </For>
                                    {/* TODO: it looks super weird when you load more posts, i suggest to use slider component here or Grid with max 3 columns */}
                                </Grid>
                                <Show when={!isLastPage()}>
                                    <ShowMoreButton orientation='horizontal' />
                                </Show>
                            </StyledPlaceHolderLatestArticlesListHorizontal>
                        </StyledPlaceHolderLatestArticlesBase>
                    </Match>
                </Switch>
            </aside>
        </ErrorCatcher>
    );
};
